var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#65707B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5V.155a1.4 1.4 0 0 0-.35.255L.41 3.15a1.4 1.4 0 0 0-.255.35H3.5zm1.4 0V0h4.9a1.4 1.4 0 0 1 1.4 1.4v.088a3.563 3.563 0 0 0-3.318.958l-4.65 4.65a2.1 2.1 0 0 0-.573 1.072l-.518 2.585a2.1 2.1 0 0 0 2.47 2.47l2.586-.516a2.1 2.1 0 0 0 1.073-.574l2.93-2.929V12.6A1.4 1.4 0 0 1 9.8 14H1.4A1.4 1.4 0 0 1 0 12.6V4.9h3.5a1.4 1.4 0 0 0 1.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.113 4.255a.763.763 0 0 1 .831.167h.001a.763.763 0 0 1 0 1.078l-.264.263-1.077-1.079.26-.262h.002a.74.74 0 0 1 .247-.166v-.001zm-1.5 1.419-3.25 3.25-.27 1.348 1.347-.27 3.251-3.25-1.078-1.078zm1.792-2.877a2.17 2.17 0 0 0-1.53.636L4.222 8.085a.7.7 0 0 0-.192.357l-.517 2.585a.7.7 0 0 0 .823.823l2.586-.517a.7.7 0 0 0 .356-.191l4.655-4.653a2.162 2.162 0 0 0-1.529-3.692z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateFile);
export default ForwardRef;